import { getErrorStatus } from '../helpers/formatters';
import { getGlobalState, messagesSelector } from '../helpers/selectors';
import { addErrorMsg } from '../utils/flashMessage/creator';
import { jsonParseSafe, safe } from '../utils/utils';
import { STORAGE_KEY } from '../constants/generic';

// [KC-DEBUG] This module-evaluation line below is the ONLY READ of localStorage
// KEYCLOAK_CONFIG in the whole codebase, and the setItem in GET_REMOTE_CONFIG_SUCCESS
// is the ONLY WRITE. The mirror read here exists purely to log what that read sees.
const kcDebugStoredRaw = safe(() => localStorage.getItem(STORAGE_KEY.KEYCLOAK_CONFIG));
const kcDebugStoredParsed = jsonParseSafe(kcDebugStoredRaw);

console.log('[KC-DEBUG] reducers/keycloak.js/module-init: READ localStorage KEYCLOAK_CONFIG (ONLY read; runs once at module load, before any brand config is fetched)', { present: kcDebugStoredRaw !== null && kcDebugStoredRaw !== undefined, rawType: typeof kcDebugStoredRaw, rawLength: kcDebugStoredRaw?.length, parsedOk: Boolean(kcDebugStoredParsed), parsedType: typeof kcDebugStoredParsed, parsedKeys: kcDebugStoredParsed ? Object.keys(kcDebugStoredParsed).join(',') : null, superCompanyId: kcDebugStoredParsed?.superCompanyId, clientId: kcDebugStoredParsed?.clientId, realm: kcDebugStoredParsed?.realm, identityProvider: kcDebugStoredParsed?.identityProvider, storageReadable: kcDebugStoredRaw !== undefined, note: 'absent => state.keycloak.remoteConfig starts undefined => parseKeycloakConfig gets be=undefined' }); // eslint-disable-line no-console
console.log('[KC-DEBUG] reducers/keycloak.js/module-init: TYPE MISMATCH WATCH - this read yields an OBJECT (jsonParseSafe), while GET_REMOTE_CONFIG_SUCCESS later puts a STRING into the same state slot', { readPathType: typeof kcDebugStoredParsed, writePathTypeWillBe: 'string', sameStateKey: 'state.keycloak.remoteConfig' }); // eslint-disable-line no-console

const defaultState = {
  isExternalIncompleteUser: false,
  remoteConfig: jsonParseSafe(localStorage.getItem(STORAGE_KEY.KEYCLOAK_CONFIG))
};

export default function reducer(state = defaultState, action) {
  switch (action.type) {
    case 'keycloak/VERIFY_FAILED': {
      const globalState = getGlobalState();
      const messages = messagesSelector(globalState);

      let errorMsg = '';

      console.log('[KC-DEBUG] reducers/keycloak.js/VERIFY_FAILED: /me failed - branching on HTTP status (404 => isExternalIncompleteUser=true => registration flow; anything else => error message, user stays logged out)', { httpStatus: getErrorStatus(action.payload) }); // eslint-disable-line no-console
      if (getErrorStatus(action.payload) === 401) {
        errorMsg = messages['error.user.verify.fail'];
      } else if (getErrorStatus(action.payload) === 422) {
        errorMsg = messages['error.login.422.user.not.enabled'];
      } else if (getErrorStatus(action.payload) === 403) {
        errorMsg = messages['error.login.403.user.anonymized'];
      } else if (getErrorStatus(action.payload) === 404) {
        state = { ...state, isExternalIncompleteUser: true };
      } else {
        errorMsg = messages['error.form.technical'];
      }

      if (errorMsg) addErrorMsg(errorMsg);

      break;
    }

    case 'keycloak/SET_REGISTER_STATUS': {
      console.log('[KC-DEBUG] reducers/keycloak.js/SET_REGISTER_STATUS: isExternalIncompleteUser transition', { from: state.isExternalIncompleteUser, to: action.payload }); // eslint-disable-line no-console
      state = { ...state, isExternalIncompleteUser: action.payload };
      break;
    }

    case 'keycloak/GET_REMOTE_CONFIG_SUCCESS': {
      const remoteConfig = JSON.stringify(action.payload.data);

      console.log('[KC-DEBUG] reducers/keycloak.js/GET_REMOTE_CONFIG_SUCCESS: storing remoteConfig as a STRING (parseKeycloakConfig later reads it as an object - see remoteConfigIsString in its ENTER log)', { superCompanyId: action.payload.data?.superCompanyId, clientId: action.payload.data?.clientId, realm: action.payload.data?.realm, identityProvider: action.payload.data?.identityProvider }); // eslint-disable-line no-console
      console.log('[KC-DEBUG] reducers/keycloak.js/GET_REMOTE_CONFIG_SUCCESS: WRITING localStorage KEYCLOAK_CONFIG (ONLY write in the codebase - it is reached ONLY after /me returns 404, which needs a successful kc.init() first)', { keyName: STORAGE_KEY.KEYCLOAK_CONFIG, valueType: typeof remoteConfig, valueLength: remoteConfig?.length, payloadDataType: typeof action.payload.data, payloadKeys: action.payload.data ? Object.keys(action.payload.data).join(',') : null }); // eslint-disable-line no-console
      localStorage.setItem(STORAGE_KEY.KEYCLOAK_CONFIG, remoteConfig);
      console.log('[KC-DEBUG] reducers/keycloak.js/GET_REMOTE_CONFIG_SUCCESS: WRITE READBACK (if writtenLength is null the storage write was silently rejected, e.g. partitioned/blocked storage)', { writtenLength: safe(() => localStorage.getItem(STORAGE_KEY.KEYCLOAK_CONFIG))?.length ?? null, writeSucceeded: safe(() => localStorage.getItem(STORAGE_KEY.KEYCLOAK_CONFIG)) === remoteConfig, stateRemoteConfigTypeNow: typeof remoteConfig }); // eslint-disable-line no-console
      state = { ...state, remoteConfig };

      break;
    }

    case 'keycloak/GET_REMOTE_CONFIG_FAIL': {
      console.log('[KC-DEBUG] reducers/keycloak.js/GET_REMOTE_CONFIG_FAIL: /v2/companies/sso-registration failed => KEYCLOAK_CONFIG is NOT written', { httpStatus: getErrorStatus(action.payload) }); // eslint-disable-line no-console
      break;
    }

    case 'keycloak/VERIFY_USER_SUCCESS': {
      console.log('[KC-DEBUG] reducers/keycloak.js/VERIFY_USER_SUCCESS: /me succeeded - the member exists, no SSO registration needed', { userId: action.payload?.data?.id, memberStatus: action.payload?.data?.status, hasCompany: Boolean(action.payload?.data?.company) }); // eslint-disable-line no-console
      break;
    }

    default: {
      break;
    }
  }

  return state;
}
